import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { requestUserSettingsOnLoginEpic } from './_epics/requestUserSettingsOnLogin.epic';
import { loadUserSettingsEpic } from './_epics/loadUserSettings.epic';
import { saveUserSettingsEpic } from './_epics/saveUserSettings.epic';
import { destroyUserSettingsOnLogoutEpic } from './_epics/destroyUserSettingsOnLogout.epic';

export const userSettingsEpic = safeCombineEpics(
  requestUserSettingsOnLoginEpic,
  loadUserSettingsEpic,
  saveUserSettingsEpic,
  destroyUserSettingsOnLogoutEpic,
);
